// Translation: Error > Landing > Message (Ukrainian)
export default Object.freeze({
	fallback: {
		title: ''
	}
})
